import React from "react";
import styled from "styled-components";
import { AnimatePresence, motion } from "framer-motion";

import { AppPageFrame } from "./AppPageFrame";
import { LoadSpinner } from "./LoadSpinner";
import { Theme } from "./Theme";

type AppPageLoaderProps = {
  text?: string;
};

export const AppPageLoader: React.FC<AppPageLoaderProps> = ({ text }) => {
  return (
    <AppPageFrame>
      <StyledViewport>
        <StyledContent>
          <StyledState>
            <LoadSpinner size={40} color={Theme.colors.accentColor} />

            <StyledTextWrap>
              <AnimatePresence mode="wait" initial={false}>
                {text ? (
                  <StyledText
                    key={text}
                    initial={{ opacity: 0, y: 6 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -6 }}
                    transition={{ duration: 0.2, ease: "easeOut" }}
                  >
                    {text}
                  </StyledText>
                ) : null}
              </AnimatePresence>
            </StyledTextWrap>
          </StyledState>
        </StyledContent>
      </StyledViewport>
    </AppPageFrame>
  );
};

const StyledViewport = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
  overflow: visible;
`;

const StyledContent = styled.div`
  flex: 1 1 auto;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 94px 18px 40px;
  box-sizing: border-box;

  @media (min-width: 768px) {
    padding: 104px 24px 44px;
  }
`;

const StyledState = styled.div`
  width: 100%;
  max-width: 408px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  text-align: center;
`;

const StyledTextWrap = styled.div`
  min-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledText = styled(motion.div)`
  color: ${Theme.colors.secondaryFontColor};
  font-size: ${Theme.font.fontSize4};
  text-align: center;
`;
